<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div v-html="html"></div>
</template>

<script setup lang="tsx">
import { useTable } from '../../../hooks/use-table';

const props = defineProps<{
  tableHeaderList: any;
  tableDataList: Array<{ [key: string]: Array<string> }>;
}>();

const className = 'cross-analysis-6';
const attrs = `border='0' bordercolor='#C0BEC7'`;
const { createTable } = useTable(props.tableHeaderList, className, attrs);
const html = createTable(props.tableDataList);
</script>
<style lang="scss">
@import '../../../styles/custom-table.scss';
.cross-analysis-6 {
  thead {
    border-top: 3px solid var(--theme-color-1);
    border-bottom: 3px solid var(--theme-color-1);
    th {
      font-weight: 600;
    }
  }
  tbody {
    border-bottom: 3px solid var(--theme-color-1);
    tr {
      border-bottom: 2pt solid #cbcbcb;
    }
  }
}
</style>
